module.exports = __webpack_public_path__ + "assets/images/icons/income.svg?v=2bb40a2b";